import React from "react";
import { CheckIcon } from "lucide-react";
type CheckListProps = {
  items: string[];
  tone?: "light" | "dark";
};
export function CheckList({
  items,
  tone = "light"
}: CheckListProps) {
  const dark = tone === "dark";
  return <ul className="list-none space-y-3 p-0" data-id="element-60" data-mp="3cnoejxa5abeb">
      {items.map(item => <li key={item} className="flex items-start gap-3" data-id="element-61" data-mp="38mmdrc0kxra8">
          <span className={`mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full ${dark ? "bg-gold/15 text-gold" : "bg-gold-cream text-gold-dark"}`} data-id="element-62" data-mp="33okv2s72ftza">
            <CheckIcon className="h-3 w-3" strokeWidth={3.5} aria-hidden="true" data-id="element-63" data-mp="2ty8d97qmyewu" />
          </span>
          <span className={dark ? "text-white" : "text-ink"} data-id="element-64" data-mp="2p06vcq4y4lmy">{item}</span>
        </li>)}
    </ul>;
}